import React, { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";

export const Shop = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    orderType: "women",
    description: "",
    budget: "",
    eventDate: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be connected to backend later
    console.log("Order Inquiry:", formData);
    toast.success("Thank you! We'll contact you within 24 hours to discuss your custom order.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      orderType: "women",
      description: "",
      budget: "",
      eventDate: ""
    });
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-[60vh] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1736005706314-3b58fe2a45d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb3V0dXJlJTIwZHJlc3N8ZW58MHx8fHwxNzcyNDY1MDc3fDA&ixlib=rb-4.1.0&q=85"
          alt="Custom Order"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div className="max-w-3xl text-white">
            <h1 className="text-6xl md:text-7xl mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Custom Orders
            </h1>
            <p className="text-xl tracking-wider">
              Let's create your perfect piece together
            </p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl text-[#C4B5A0] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                01
              </div>
              <h3 className="text-xl mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Submit Your Inquiry
              </h3>
              <p className="text-[#8B7D6B]">
                Tell us about your vision, event, and preferences
              </p>
            </div>
            <div>
              <div className="text-4xl text-[#C4B5A0] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                02
              </div>
              <h3 className="text-xl mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Consultation
              </h3>
              <p className="text-[#8B7D6B]">
                We'll schedule a call to discuss details and options
              </p>
            </div>
            <div>
              <div className="text-4xl text-[#C4B5A0] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                03
              </div>
              <h3 className="text-xl mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Creation Begins
              </h3>
              <p className="text-[#8B7D6B]">
                Your custom piece is handcrafted with love
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Order Form */}
      <section className="py-24 px-6 bg-[#FAF9F7]">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-5xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Request a Custom Order
            </h2>
            <p className="text-[#8B7D6B] tracking-wide">
              Fill out the form below and we'll get back to you within 24 hours
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-lg shadow-xl">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  FULL NAME *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                  placeholder="Your name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  EMAIL ADDRESS *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  PHONE NUMBER *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                  placeholder="+234 XXX XXX XXXX"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  ORDER TYPE *
                </label>
                <select
                  name="orderType"
                  value={formData.orderType}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                >
                  <option value="women">Women's Couture</option>
                  <option value="girls">Girls' Couture</option>
                  <option value="both">Mother & Daughter Set</option>
                </select>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  BUDGET RANGE
                </label>
                <select
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                >
                  <option value="">Select budget range</option>
                  <option value="under500k">Under ₦500,000</option>
                  <option value="500k-1m">₦500,000 - ₦1,000,000</option>
                  <option value="1m-2m">₦1,000,000 - ₦2,000,000</option>
                  <option value="above2m">Above ₦2,000,000</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                  EVENT DATE
                </label>
                <input
                  type="date"
                  name="eventDate"
                  value={formData.eventDate}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors"
                />
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-[#2C2C2C] mb-2 tracking-wide">
                DESCRIBE YOUR VISION *
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
                rows="6"
                className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:border-[#C4B5A0] focus:ring-1 focus:ring-[#C4B5A0] transition-colors resize-none"
                placeholder="Tell us about the occasion, your style preferences, colors, fabrics, and any special details you'd like..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-[#C4B5A0] text-[#2C2C2C] tracking-widest font-medium hover:bg-[#D4C4B0] transition-all duration-300 rounded shadow-lg flex items-center justify-center"
            >
              <Send className="mr-2" size={20} />
              SUBMIT INQUIRY
            </button>

            <p className="text-center text-[#8B7D6B] text-sm mt-6">
              We'll respond to your inquiry within 24 hours
            </p>
          </form>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-[#FAF9F7] p-8 rounded-lg">
              <h3 className="text-2xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Timeline
              </h3>
              <p className="text-[#8B7D6B] leading-relaxed">
                Custom couture pieces typically take 8-12 weeks from initial consultation to 
                final delivery. Rush orders may be available for an additional fee.
              </p>
            </div>

            <div className="bg-[#FAF9F7] p-8 rounded-lg">
              <h3 className="text-2xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Payment
              </h3>
              <p className="text-[#8B7D6B] leading-relaxed">
                50% deposit required to begin work, with the balance due upon completion. 
                We accept bank transfers and international payments.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
